import React from 'react'

import { Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledTextField } from 'components/common'
import { UpdateSmsTemplateInput } from 'generated/graphql'

const SmsFormControls = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<UpdateSmsTemplateInput>()

  return (
    <Grid container rowSpacing={1.5} columnSpacing={3} sx={{ marginBottom: 'unset' }}>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          label='Message'
          name='message'
          defaultValue=''
          required
          multiline
          rows={6}
          error={!!errors.message}
          helperText={errors.message?.message || 'Maximum 160 characters for SMS'}
        />
      </Grid>
    </Grid>
  )
}

export default SmsFormControls
